<template>
  <div class="create-tracking-category-popup-flow">
    <create-tracking-category-popup v-if="currentComponent === componentNames.createTrackingCategoryPopup"
                                    @done-clicked="showNext()" @close="close()"/>
    <create-other-tracking-category-popup v-if="currentComponent === componentNames.createOtherTrackingCategoryPopup"
                                    @done-clicked="showNext()" @back-clicked="showPrevious()"/>
    <create-tracking-category-amount-popup v-else-if="currentComponent === componentNames.createTrackingCategoryAmountPopup"
                                           @done-clicked="showNext()" @back-clicked="showPrevious()"/>
    <create-tracking-category-duration-popup v-else-if="currentComponent === componentNames.createTrackingCategoryDurationPopup"
                                             v-on:close="close()" @back-clicked="showPrevious()"/>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapState, mapGetters } from 'vuex';
import featureFlag from '@/api/featureFlag';
import EventBus from '@/event-bus/event-bus';
import Segment from '@/Segment';
import NewTrackingCategoryToaster
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/toasters/NewTrackingCategoryToaster';
import CreateTrackingCategoryPopup from './CreateTrackingCategoryPopup.vue';
import CreateOtherTrackingCategoryPopup from './CreateOtherTrackingCategoryPopup.vue';
import CreateTrackingCategoryAmountPopup from './CreateTrackingCategoryAmountPopup.vue';
import CreateTrackingCategoryDurationPopup from './CreateTrackingCategoryDurationPopup.vue';

const componentNames = {
  createTrackingCategoryPopup: 'create-tracking-category-popup',
  createOtherTrackingCategoryPopup: 'create-other-tracking-category-popup',
  createTrackingCategoryAmountPopup: 'create-tracking-category-amount-popup',
  createTrackingCategoryDurationPopup: 'create-tracking-category-duration-popup',
};

export default {
  name: 'CreateTrackingCategoryPopupFlow',
  components: {
    CreateTrackingCategoryPopup,
    CreateOtherTrackingCategoryPopup,
    CreateTrackingCategoryAmountPopup,
    CreateTrackingCategoryDurationPopup,
  },
  data() {
    return {
      currentComponent: componentNames.createTrackingCategoryPopup,
      showDurationStep: false,
    };
  },
  computed: {
    ...mapState('createTrackingCategory', ['isCustomTrackingCategory', 'selectedTrackingCategory']),
    ...mapGetters('createTrackingCategory', ['transactionsToTrack']),
    ...mapGetters('editTransaction', ['ENRICHMENT_INPUT_TYPES']),
    componentNames() {
      return componentNames;
    },
  },
  async created() {
    this.showDurationStep = await featureFlag.getTreatment('tracking-category-duration') === 'on';
  },
  methods: {
    ...mapActions('createTrackingCategory', ['reset', 'showTrackingCategory']),
    ...mapActions('editCashflow', ['moveTransaction']),
    showNext() {
      if (this.currentComponent === this.componentNames.createTrackingCategoryPopup
        && this.isCustomTrackingCategory) {
        this.currentComponent = componentNames.createOtherTrackingCategoryPopup;
      } else if (this.currentComponent === this.componentNames.createOtherTrackingCategoryPopup
              || this.currentComponent === this.componentNames.createTrackingCategoryPopup) {
        this.currentComponent = componentNames.createTrackingCategoryAmountPopup;
      } else if (this.currentComponent === this.componentNames.createTrackingCategoryAmountPopup) {
        if (this.showDurationStep) {
          this.currentComponent = componentNames.createTrackingCategoryDurationPopup;
        } else {
          this.createCategoryWithoutDurationStep();
        }
      }
    },
    async createCategoryWithoutDurationStep() {
      Segment.trackUserInteraction('CreateTrackingCategory_SkippedDurationStep');
      const newTrackingCategory = await this.showTrackingCategory();
      _.forEach(this.transactionsToTrack, transaction => {
        this.moveTransaction({
          originalCategory: transaction.trackingCategory,
          selectedCategory: newTrackingCategory,
          transaction,
          categoryRuleType: this.ENRICHMENT_INPUT_TYPES.TRANSACTION_ID,
          valueForPredicate: transaction.transactionId,
        });
      });
      EventBus.$emit('open-toaster', {
        component: NewTrackingCategoryToaster,
        props: {
          trackingCategoryName: this.selectedTrackingCategory.label,
        },
      });
      this.close();
    },
    showPrevious() {
      if (this.currentComponent === this.componentNames.createTrackingCategoryDurationPopup) {
        this.currentComponent = componentNames.createTrackingCategoryAmountPopup;
      } else if (this.currentComponent === this.componentNames.createTrackingCategoryAmountPopup
        && this.isCustomTrackingCategory) {
        this.currentComponent = componentNames.createOtherTrackingCategoryPopup;
      } else if (this.currentComponent === this.componentNames.createTrackingCategoryAmountPopup) {
        this.currentComponent = componentNames.createTrackingCategoryPopup;
      } else if (this.currentComponent === this.componentNames.createOtherTrackingCategoryPopup) {
        this.currentComponent = componentNames.createTrackingCategoryPopup;
      }
    },
    close() {
      this.reset();
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  .create-tracking-category-popup-flow {
    display: flex;
    flex-direction: column;
  }
</style>
